import { DoughnutChart, BarLineChart, BarChart, LineChart } from '@geberit/gdds';
import KeyFigure from './key-figure';

export const CHART_COMPONENTS = {
  chart_doughnut: DoughnutChart,
  chart_bar_and_line: BarLineChart,
  chart_bar: BarChart,
  chart_line: LineChart,
  chart_key_figure: KeyFigure,
};
